import { render, staticRenderFns } from "./detail_event.vue?vue&type=template&id=396beab3&scoped=true&"
import script from "./detail_event.vue?vue&type=script&lang=js&"
export * from "./detail_event.vue?vue&type=script&lang=js&"
import style0 from "./detail_event.vue?vue&type=style&index=0&id=396beab3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396beab3",
  null
  
)

export default component.exports